export const chapter8 = [

    //page 68
    'Eager to wet their spears in blood they sped towards their quarry,',
    'The first Gobbo to claim the kill would earn their tribe the glory,',
    'As they got close Andell peeked but tripped on the forest floor,',
    'The Gobbos charged -impatient for death with a hiss and a roar,',
    'They fell upon Andell but found no easy victim to slaughter,',
    'She parried their thrusts and stabbed like a war-god‘s daughter,',
    'The trap was sprung as a volley of bolts impale the Gobbo‘s torsos,',
    'Garson tuned his upgraded mechanism -how it worked who knows?',
    'They begin to retreat as their numbers drop with a thud,',
    'Sigg pounced from behind them relieving them of their blood,',
    'A flurry of stabs, riposte, parry then a quick thrust,',
    'The Gobbo hunting party all bleed out in to the dust,',

    //page 69
    '“Help me stage the bodies, as if their minds were broken”,',
    '“With luck their Shaman will think a spell had been spoken”,',
    'Following Sigg‘s lead they quickly set to arrange,',
    'The bloody scene before the rest were in range,',
    'Garson snatched his bolts as they retreated to the pines,',
    'Just as the Shaman finished reading into mystic signs,',
    'He shook his staff and the Gobbo army again moved out,',
    'As he looked for the hunters the Shaman heard another shout,',
    '“Andell now“ Sigg signals from their position on the top of a ridge,',
    'She summons three crows -one missing the Shaman by a smidge,',
    'Perfectly timed they then stumble upon the dead hunting pack,',
    'The Shaman now knows the magics are calling his army back,',
    'He raised his staff and spins it twice around,',
    'Sigg couldn‘t have hoped for a better sound,',
    'But squabbling and fighting erupt through the numerous horde,',
    'The Shaman fails to calm them and is run through with a sword,',
    'The new Shaman spits onto his cowardly predecessor,',
    'His reign applauded -war was time to be the aggressor!',
    'After some shouting the Gobbos again pick up the pace,',
    'Sigg‘s hope to dissuade them vanished without a trace,',
    'The horde reached the rocky verge and split their force in two,',
    'This was a good a chance as they would get Sigg now knew,',

    //page 70
    '“For Cragknoll!” Sigg roared charging from his concealed position,',
    'He cleaved through bone and skull determined to fulfil his mission,',
    'The Gobbos surged toward him keen to see his blood spill,',
    'But quick as he could Sigg disengaged and ran toward the hill,',
    'The front packs of Gobbos gave chase closing the gap,',
    'Garson lobbed a few small objects wrapped in burlap,',
    'As they flew through the air they burst into yellow flame,',
    'Gouts of fire lashed out hot enough to severely maim,',
    'As the fires caught the bushes the choking smoke grew,',
    'The undisciplined Gobbo formation was now split in two,',
    'Andell leapt from her hidden spot to join Sigg in knife work,',
    'Garson unloaded more deadly bolts from where he did lurk,',
    'The lead Gobbo packs were ravaged with bolt and blade,',
    'The three heroes racked up the kills on their deadly raid,',
    'As the fires eased and the smoke dissipated,',
    'They drew back to the forest and again waited,',
    'Sigg‘s plan was to bite off chunks and chew them up,',
    'So far so good, but they knew that they had no backup,',
    'Gobbos leapt through the dying flames and joined the hunt,',
    'Garson rewarded them with deadly projectiles into the front,',
    'A scattering of Gobbos fell as others charged Garson,',
    'Some limped along behind still stinging from his arson,',

    //page 71
    'Andell emerged from behind a tree and sliced two Gobbos dead,',
    'As they turned their focus on her she parried their stabs and fled,',
    'Sigg strode forward into their lines rending flesh and spilling guts,',
    'He was not used to the lighter armour and this sped up his cuts,',
    'For a moment Sigg was in a zen-like state,',
    'At last he could quench his long-brewed hate,',
    'But as the Gobbos piled in Sigg could only parry his best,',
    'One spear got past his guard and dug into his chest,',
    '“Sigg duck!” Garson unleashed another volley of spikes,',
    'He managed to roll in time and avoided their sharp pikes,',
    'Coming to his senses Sigg made a dash rearwards,',
    'He choked down the pain with a mix of swearwords,',
    'Andell had kept running and had escaped to quite a distance,',
    'For this next vulnerable part she‘d need her friends assistance,',
    'Garson slung his custom crossbow onto his shoulder for now,',
    'He drew his axe on the Gobbos and began to hack and plough,',
    'Sigg made his way over and the two of them fought hard,',
    'If they were going to live through this they‘d be scarred,',
    'They collected more cuts as sheer numbers made their mark,',
    'They protected Andell as if she was their precious matriarch,',
    'She stood breathing deeply, eyes closed yelling her power,',
    'They knew the risk was high, but it needed all her willpower,',

    //page 72
    'Sigg and Garson dropped back, running from their foe,',
    'They had a little ground to spare, just a stone’s throw,',
    'The Gobbos saw them retreat and bared down on them,',
    'Fighting was fierce and Sigg howled “Die Gobbo scum!”',
    'Precious seconds strolled by as they lost more ground,',
    'Then from the east came a thunderous galloping sound,',
    'Andell lowered her arms and caught her breath as she saw,',
    'A large herd of deer with antlers lowered enter in to the war,',
    'The beasts sped through bushes and Gobbo alike, ',
    'Broken bodies bowled and trampled as they strike,',
    'Granting the three a needed reprieve they withdraw,',
    'Hoping that‘ll buy them some time perhaps a bit more,',
    'After they are spent they collapse into the vegetation,',
    '“Now drink!” Andell called as she felt the sensation,',
    'Sigg remembered Andell‘s gift and chugged down the vial,',
    'A rush of energy flooded his body he could run for a mile!',
    'Garson did the same and a smile spread across his face,',
    'He began jumping foot to foot like ready for a race,',
    'Sigg leapt to his feet and scanned north through the treeline,',
    'His whole body began to tingle -he took that as a good sign,',
    '“Charge!” He found himself calling his body eagerly reacting,',
    'They rushed back into battle while the deer were distracting,',

    //page 73
    'After suffering losses the deer began to scatter,',
    'They earnt many kills evidenced by blood splatter, ',
    'Now immersed in the bloody melee they carved out death,',
    'Sigg found himself soaking in extra energy with each breath,',
    'They lost track of time cutting their way into the enemy force,',
    '“Retreat!” Andell cried and ran back with the speed of a horse,',
    '“Are you hurt Andell?” Sigg checked her over for harm,',
    'She wore blood splashes all over her and cut on her arm,',
    '“I‘ll be fine, but we must spend this energy wisely, lest it be drained”,',
    '“Agreed“ It was hard to tell if Garson was hurt being so bloodstained,',
    'The Cragknoll gate bell rippled through the forest air,',
    'Despite heavy losses the Gobbos must‘ve made it there,',
    'With a panicked look Sigg called “To the gate with haste!”,',
    'They ran wildly with weapons drawn all while being chased,',
    'Breaking out of the forest the Cragknollian wall was now in sight,',
    'They were outmanoeuvred as another tribe stood ready to fight,',
    'A few Cragknollian guards manned the wall with arrow and bow,',
    'The blood on the wall showed many had been brought low,',
    'Head and shoulders above the rest Sigg spotted three amid the crowd,',
    'Eanom, Iron-jaw and Rothkuul directing their minions with orders loud,',
    '“Break those hinges!” Iron-jaw in frustration barked,',
    'Gobbo spears did little damage but left them marked,',

    //page 74
    'He shoved them aside and brought club to bear,',
    'After a few hits on the hinges he busted the pair,',
    'With another several thumps the gate crashed down,',
    'The entire Gobbo army now had access to the town,',
    '“No!” Sigg cried as he ran the closest Gobbo right through,',
    'He desperately tried to make his way with hack and hew,',
    'The Gobbos flooded through the breach met with screams,',
    'Villagers ran for their lives as Sigg lived his worst dreams,',
    'Andell clapped her hands and again summoned her battle deer,',
    'They burst out from the forest leaping past many Gobbo spear,',
    'Using her hands to guide them she targeted the biggest threat,',
    'They gouged Gobbos on the way to Rothkuul now with blood wet,',
    'Before reaching their target Rothkuul turned and pointed his staff,',
    'Speaking wicked words the deer flee in terror and he begins to laugh,',
    'With a wave of his hand more of his army towards Andell rush,',
    '“Come to your death!” She cried -wild slices blood starts to gush,',
    'The heroes follow through the broken gate and witness the mayhem,',
    'Wheat fields, farmhouses and blood splattered paths greet them,',
    'Sigg sees his countrymen fall to his arch-foe, his blood turns icy,',
    'This was the worst-case scenario -things were sure Getting Dicey!',
    'They harry the Gobbos on the path to the village square, ',
    'From all directions panicked screams pierce the cold air,',

    //page 75
    'Andell and Garson see wooden homes starting to burn,',
    'They swiftly cut down murderous Gobbos at every turn,',
    'After so long Sigg sees his homeland it’s unreal,',
    'Now profaned by Gobbos he kills them with zeal,',
    'The villagers flee to the town hall, the largest building in sight,',
    'Not all make it before the doors shut and put up a meagre fight,',
    'Mercilessly Gobbo spears put to an end their weak opposition,',
    'Two Cragknollian knights carve a path of blood -on a mission,',
    'They stood side-by-side protecting the doors of the hall,',
    'A mob of Gobbos rush them but are killed in the brawl,',
    '“They look good to kill!” Iron-jaw taunts in a loud vocals,',
    'But the steel-clad pair ignore him and defend the locals,',
    'Garson unslings his weapon and loads up his last shots,',
    'He fired at Iron-jaw and several impact and hurt him lots,',
    'He roared out in pain, but somehow remains upright,',
    'Iron-jaw‘s eyes search and find Garson laden with spite,',
    'He bowls his way through Gobbos eager for his next kill,',
    'Garson readies his axe and hopes he can rely on his skill,',
    'Iron-jaw runs in with a sweep of his club - a deadly blow,',
    'Garson fends but his grip lost -not how he wanted it to go,',
    'Iron-jaw bellows with laughter as he grabs him and lifts,',
    'Struggling to breathe Garson is showered in pain’s gifts,',

    //page 76
    'For a more personal touch Iron-jaw decides to punch,',
    'Garson buckles on impact and feels his bones crunch,',
    'Sigg dashes over to help but Eanom stands in the way,',
    'Blade ready Sigg calls out “Treacherous fiend I will slay!”,',
    'Eanom is not phased and launches a flurry of attacks,',
    'Fending off the strikes Sigg is stopped in his tracks,',
    'Relishing in his victory Iron-jaw presses close his face,',
    '“Once I‘m finished here they‘ll find you all over the place”,',
    'Garson squirms and manages to reach a pocket from his coat,',
    'He opens the cork and blew black powder into Iron-jaws throat,',
    'After a brief cough Iron-jaw tightens his grip “It’s no use!”,',
    'A popping sound triggers Iron-jaws grip to suddenly loose,',
    'His scream cut off as a large pot denotates his neck from the inside,',
    'Iron-jaw‘s lungs now home to utensils -that instant he promptly died,',
    'Dropping to his knees Garson tried to catch his breath,',
    'Aware that if things went differently it‘d be his death,',
    'Rothkuul was taken aback by the death of his brute,',
    '“You‘ve bought yourself just minutes, your win is moot”,',
    'He raised his staff at the Cragknollian knights clad in plate,',
    'They lost the willpower battle and charged at Sigg full of hate,',
    '“No brothers stop!” Sigg pleaded parrying Eanom‘s thrust,',
    'The two knights attacked and Sigg dodged but only just,',

    //page 77
    'With an instinctive counter he returned with a quick strike, ',
    'Sigg stopped short, he knew what this mind-spell was like,',
    'Three against one all Sigg could do was defend,',
    'If this was his last stand he would fight to the end,',
    '“Fight for our homes, our families and all we love!”',
    'Sigg begged his kin but was met with mailed glove,',
    'Rothkuul stood witness to the fall of Cragknoll at last,',
    'He began weave his dark magics of his spell to cast,',
    '“For Cragknoll!” Andell declared as she threw her arms wide,',
    'The birds she had been summoning could now longer hide,',
    'In from the forest towards Rothkuul flew the storm of crows,',
    'He bent the minds of some but all of them he could not oppose,',
    'The birds pecked and scratched with beak and sharp claw,',
    'Rothkuul screamed until breath he could no longer draw,',
    'The mess of feathers made splashes of red,',
    'It was clear to all that he was now very dead,',
    'The two knights traded glances and swung their swords,',
    'Eanom was cleaved in half with no time for final words,',
    'With no-one left alive to lead them the Gobbos began to flee,',
    'Sigg and knights ran to broken gate “Try and get through me!”,',
    'Villagers burst from their homes with axe and rake,',
    'With nowhere to go the Gobbos morale began to break,',


    //page 78
    '“Kill ‚em all!” Sigg roared as they slaughtered every last one,',
    'After ensuring all wounded were dead the fighting was done,',
    'Sigg slowly caught his breath, his village was safe again!',
    'He checked on Andell and Garson, both hurt but not slain.',


];